import React from 'react'

import IconButton from './icon-button'

export default class TextAreaSubmit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentText: undefined,
            currentLength: 0,
            hideLength: this.props.hideLength,
        }
    }

    onChange = (event) => {
        this.setState({
            currentText: event.target.value,
            currentLength: event.target.value.length,
        })
    }

    onSubmit = () => {
        
        this.props.onSubmit(this.state.currentText)

        if (this.props.clearOnSubmit) {
            this.setState({currentText: "", currentLength: 0})
        }
    }

    render() {
        return (
            <div className="stand-alone-textarea-container">
                <textarea
                    className="form-control"
                    rows={this.props.rows}
                    placeholder={this.props.placeholder}
                    maxLength={this.props.maxLength}
                    defaultValue={this.props.text}
                    value={this.state.currentText}
                    onChange={this.onChange}></textarea>

                {this.state.hideLength ? (
                    <></>
                ) : (
                    <p className="text-muted">
                        <small>
                            {' '}
                            {this.state.currentLength} / {this.props.maxLength}
                        </small>
                    </p>
                )}
                <h5>
                    <IconButton
                        onClick={this.onSubmit}
                        disabled={this.state.currentLength === 0}
                        icon={'paper-plane'}
                    />
                </h5>
            </div>
        )
    }
}
